<div class="modal-header">
    <h4 class="modal-title">{{ isNewProperty ? 'Add New Property' : 'Edit Property' }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>
<div class="modal-body">
    <form #propertyForm="ngForm">
        <!-- Type -->
        <div class="form-group row mb5">
            <label for="type" class="col-sm-2 col-form-label">Type <span class="req-color">*</span></label>
            <div class="col-sm-10">
                <select class="form-control" [ngClass]="{'readonly-select': !isNewProperty}" id="type" name="type" [(ngModel)]="model.type" [disabled]="!isNewProperty" required>
                    <option value="">Select type...</option>
                    <option value="ItemAttribute">ItemAttribute</option>
                    <option value="GENERIC">GENERIC</option>
                </select>
               <!-- <div *ngIf="propertyForm.controls['key'].invalid && (propertyForm.controls['key'].dirty || propertyForm.controls['key'].touched)" class="alert alert-danger">
                    <div *ngIf="form.parser.errors?.['required']">Name is required.</div>
                </div> -->
            </div>
        </div>

        <!-- Key -->
        <div class="form-group row mb5">
            <label for="key" class="col-sm-2 col-form-label">Key <span class="req-color">*</span></label>
            <div class="col-sm-10">

                <input type="text" class="form-control" id="key" name="key" [(ngModel)]="model.key" [readonly]="!isNewProperty" required>
               <!-- <div *ngIf="propertyForm.controls['key'].invalid && (propertyForm.controls['key'].dirty || propertyForm.controls['key'].touched)" class="alert alert-danger">
                    <div *ngIf="form.parser.errors?.['required']">Name is required.</div>
                </div> -->
            </div>
        </div>
        
        <!-- Value -->
        <div class="form-group row mb5">
            <label for="value" class="col-sm-2 col-form-label">Value <span class="req-color">*</span></label>
            <div class="col-sm-10">

                <input type="text" class="form-control" id="value" name="value" [(ngModel)]="model.value" required="">
               <!-- <div *ngIf="propertyForm.controls['key'].invalid && (propertyForm.controls['key'].dirty || propertyForm.controls['key'].touched)" class="alert alert-danger">
                    <div *ngIf="form.parser.errors?.['required']">Name is required.</div>
                </div> -->
            </div>
        </div>

        <!-- Origin source -->
        <div class="form-group row mb5">
            <label for="originSource" class="col-sm-2 col-form-label">Origin source</label>
            <div class="col-sm-10">

                <input type="text" class="form-control" id="originSource" name="originSource" [(ngModel)]="model.originSource" [readonly]="true">
               <!-- <div *ngIf="propertyForm.controls['key'].invalid && (propertyForm.controls['key'].dirty || propertyForm.controls['key'].touched)" class="alert alert-danger">
                    <div *ngIf="form.parser.errors?.['required']">Name is required.</div>
                </div> -->
            </div>
        </div>

        <!-- Publishing source -->
        <div class="form-group row mb5">
            <label for="publishingSource" class="col-sm-2 col-form-label">Publishing source</label>
            <div class="col-sm-10">

                <input type="text" class="form-control" id="publishingSource" name="publishingSource" [(ngModel)]="model.publishingSource" [readonly]="true">
               <!-- <div *ngIf="propertyForm.controls['key'].invalid && (propertyForm.controls['key'].dirty || propertyForm.controls['key'].touched)" class="alert alert-danger">
                    <div *ngIf="form.parser.errors?.['required']">Name is required.</div>
                </div> -->
            </div>
        </div>

        <!-- Taxonomy node ID -->
        <div class="form-group row mb5">
            <label for="taxonomyNodeId" class="col-sm-2 col-form-label">Taxonomy node ID</label>
            <div class="col-sm-10">

                <input type="text" class="form-control" id="taxonomyNodeId" name="taxonomyNodeId" [(ngModel)]="model.taxonomyNodeId" [readonly]="!isNewProperty">
               <!-- <div *ngIf="propertyForm.controls['key'].invalid && (propertyForm.controls['key'].dirty || propertyForm.controls['key'].touched)" class="alert alert-danger">
                    <div *ngIf="form.parser.errors?.['required']">Name is required.</div>
                </div> -->
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-outline-dark" (click)="save()" [disabled]="!propertyForm.form.valid">Save</button>
</div>
